import React from 'react'
import './index.scss'

import Button from '../Button'
import {getQueryString} from '../../Utils/Utils'

export default function Dialog(props) {
  let { visible, setVisible, title, titleStyle, btns, children, closeCb, hideClose, big } = props

  return (<div className={"Dialog" + (visible ? '' : ' hide')}>
    <section className={big ? "dialogDontainer big":"dialogDontainer"}>
      {!hideClose && <div className="close" onClick={() => {
        if (window.toBind || getQueryString("claimSinger")) {//认领歌手
          if (window.LC.isIOS) {
            window.LC.mobileCall(158, { type: 1 })
          } else {
            window.LC.mobileCall(158, { type: 2 })
          }
        } else {
          setVisible(false);
          closeCb && closeCb();
        }
      }}></div>}
      <header className="title" style={titleStyle}>{title}</header>
      {children}

      {btns &&
        <footer className={btns.length > 0 ? "multi-btns btns":"btns"}>
          {btns.map((ele, index) => (<Button key={index} text={ele.text} fn={ele.fn} />))}
        </footer>}

    </section>

  </div>)
}